import { render, staticRenderFns } from "./Olumajek.vue?vue&type=template&id=2c6a900c&scoped=true&"
import script from "./Olumajek.vue?vue&type=script&setup=true&lang=js&"
export * from "./Olumajek.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Olumajek.vue?vue&type=style&index=0&id=2c6a900c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6a900c",
  null
  
)

export default component.exports